module.exports = __webpack_public_path__ + "static/elf_sun_male_SCAG-9e8097bb6d24f97a918ac7040cffb88d.png";